import AccordionItem from 'components/shared/BaseAccordion/AccordionItem/AccordionItem';
import { getIdFromText, getColorwayName } from 'utils/formatters';
import { ToggleProps } from 'libs/contentful/props';
import { Colorways } from 'types/constants';

import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn } from '@/utils/styles';

const Toggle = ({ sys, tabCopy, accordionItems, color }: ToggleProps) => {
  // Determine accordion colorway based on FAQ module's color prop
  // Using explicit class names so Tailwind can detect them during build
  const getAccordionColorwayClass = () => {
    const colorwayName = getColorwayName(color);
    if (colorwayName === Colorways.Primary || colorwayName === Colorways.Secondary) {
      // Explicit class name for Tailwind detection
      return 'open:dark-green-colorway';
    }
    // Explicit class name for Tailwind detection
    return 'open:light-green-colorway';
  };

  return (
    <div
      className={`panel mt-6 md:mt-14`}
      id={`panel-${getIdFromText(tabCopy)}`}
      {...liveUpdateAttrs(sys?.id, 'content')}>
      {accordionItems.items?.map((item, i) => (
        // We intentionally do not pass isFirstElement as a prop to AccordionItem because
        // we do not want the first item to be open by default for the Toggle component
        <AccordionItem
          sectionName={item.sectionName}
          sys={item.sys}
          accordionLabelRte={item.accordionLabelRte}
          accordionCopy={item.accordionCopy}
          key={`accordion-item-${i}`}
          className={cn(
            getAccordionColorwayClass(),
            `open:rounded-md open:mb-2 px-6 open:p-6 md:open:-mx-6 md:px-0 open:[&_td]:text-[unset]`,
          )}
          showSimpleListStyle
        />
      ))}
    </div>
  );
};

export default Toggle;
